// src/hooks/useLeadershipPageStatus.js
import { useEffect, useState } from "react";
import { getLeadershipPageStatus } from "../api/LeadershipApis";

/**
 * Returns { enabled, loading }.
 * - enabled: null while loading, then true/false
 * - Caches in sessionStorage so only one fetch per tab session
 * - Fails open (returns true) if the backend is unreachable
 */
export default function useLeadershipPageStatus() {
  const [enabled, setEnabled] = useState(() => {
    const cached = sessionStorage.getItem("leadership-page-enabled");
    return cached === null ? null : cached === "true";
  });
  const [loading, setLoading] = useState(() => {
    return sessionStorage.getItem("leadership-page-enabled") === null;
  });

  useEffect(() => {
    if (enabled !== null) return;

    let cancelled = false;

    getLeadershipPageStatus()
      .then((res) => {
        if (cancelled) return;
        const value = Boolean(res.data?.is_enabled);
        setEnabled(value);
        sessionStorage.setItem("leadership-page-enabled", String(value));
      })
      .catch(() => {
        if (cancelled) return;
        setEnabled(true);
        sessionStorage.setItem("leadership-page-enabled", "true");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { enabled, loading };
}